/*
 * Copyright 2022 Siemens
 */

import {SwwcLoadingIndicator} from '@com.siemens.plm.horizon/swwc/bindings/react';
import React from 'react';

interface ContentProps {
  isLoading: boolean;
  section: string;
  children: React.ReactNode | ReadonlyArray<React.ReactNode>;
}

export class Content extends React.Component<ContentProps> {
  override render() {
    return (
      <React.Fragment>
        <h1>{this.props.section}</h1>
        {this.props.isLoading ? <SwwcLoadingIndicator /> : this.props.children}
      </React.Fragment>
    );
  }
}
